
<form [formGroup]="formGroup">
  <app-basic-load-configuration-options
    [formGroup]="formGroup"
    [configuration]="configuration"
    [configurationMode]="configurationMode">
  </app-basic-load-configuration-options>
</form>